import {combineReducers} from 'redux';
import uuid from 'uuid';
import moment from 'moment';
import {
  updatePeople,
  updateAgenda,
  updateHomepage as apiUpdateHomepage,
  addPointsChange as apiAddPointsChange,
  uploadFile,
} from '../module/API';
import {
  agendaDatesSelector,
} from './dataReducer';
import {
  agendaEditSelector as rootAgendaEditSelector,
} from './';

// *** REDUCERS

const homepageReducer = (state = null, action) => {

  switch(action.type) {

    case 'EDIT_HOMEPAGE':
      return action.homepage;

    case 'CANCEL_EDIT_HOMEPAGE':
    case 'SAVE_HOMEPAGE_SUCCESS':
      return null;

    case 'UPDATE_HOMEPAGE':
      return {
        ...state,
        ...action.delta,
      };

    default:
      return state;

  }

};

const peopleReducer = (state = null, action) => {

  switch(action.type) {

    case 'EDIT_PEOPLE':
      return action.people;

    case 'CANCEL_EDIT_PEOPLE':
    case 'SAVE_PEOPLE_SUCCESS':
      return null;

    case 'ADD_PERSON':
      return {
        ...state,
        [uuid()]: {
          name: ''
        }
      };

    case 'REMOVE_PERSON':
      if ( state[action.id] ) {
        return {
          ...state,
          [action.id]: null
        };
      } else {
        return state;
      }

    case 'UPDATE_PERSON':
      if ( state[action.id] ) {
        return {
          ...state,
          [action.id]: {
            ...state[action.id],
            ...action.delta
          }
        };
      } else {
        return state;
      }

    default:
      return state;

  }

};

const agendaReducer = (state = null, action) => {

  let people, index, rooms;

  switch(action.type) {

    case 'EDIT_AGENDA':
      return action.agenda;

    case 'CANCEL_EDIT_AGENDA':
    case 'SAVE_AGENDA_SUCCESS':
      return null;

    case 'ADD_AGENDA_DAY':
      return {
        ...state,
        [uuid()]: {
          ...action.agendaDay
        }
      };

    case 'UPDATE_AGENDA_DAY':
      if ( state[action.id] ) {
        return {
          ...state,
          [action.id]: {
            ...state[action.id],
            ...action.delta,
          },
        };
      } else {
        return state;
      }

    case 'REMOVE_AGENDA_DAY':
      if ( state[action.id] ) {
        return {
          ...state,
          [action.id]: null,
        };
      } else {
        return state;
      }

    case 'UPDATE_AGENDA_ITEM':
      if ( state[action.dayId] ) {
        return {
          ...state,
          [action.dayId]: {
            ...state[action.dayId],
            items: {
              ...state[action.dayId].items,
              [action.itemId]: {
                ...state[action.dayId].items[action.itemId],
                ...action.delta,
              },
            }
          }
        };
      } else {
        return state;
      }

    case 'REMOVE_AGENDA_ITEM':
      if ( state[action.dayId] ) {
        return {
          ...state,
          [action.dayId]: {
            ...state[action.dayId],
            items: {
              ...state[action.dayId].items,
              [action.itemId]: null,
            }
          }
        };
      } else {
        return state;
      }

    case 'ADD_AGENDA_ITEM':
      if ( state[action.dayId] ) {
        return {
          ...state,
          [action.dayId]: {
            ...state[action.dayId],
            items: {
              ...state[action.dayId].items,
              [uuid()]: {}
            }
          }
        };
      } else {
        return state;
      }

    case 'ADD_PERSON_TO_AGENDA_DAY':
      if ( state[action.dayId] ) {
        people = state[action.dayId].people || [];
        return {
          ...state,
          [action.dayId]: {
            ...state[action.dayId],
            people: [
              ...people,
              action.personId
            ]
          }
        };
      } else {
        return state;
      }

    case 'REMOVE_PERSON_FROM_AGENDA_DAY':
      if ( state[action.dayId] ) {
        people = state[action.dayId].people || [];
        index = people.indexOf(action.personId);
        if ( index > -1 ) {
          return {
            ...state,
            [action.dayId]: {
              ...state[action.dayId],
              people: [
                ...people.slice(0, index),
                ...people.slice(index+1),
              ]
            }
          };
        } else {
          return state;
        }
      } else {
        return state;
      }

    case 'SET_AGENDA_DAY_PEOPLE':
      if ( state[action.dayId] ) {
        return {
          ...state,
          [action.dayId]: {
            ...state[action.dayId],
            people: [
              ...action.personIds,
            ]
          }
        };
      } else {
        return state;
      }

    case 'CLEAR_AGENDA_DAY_PEOPLE':
      if ( state[action.dayId] ) {
        return {
          ...state,
          [action.dayId]: {
            ...state[action.dayId],
            people: [],
          }
        };
      } else {
        return state;
      }

    case 'ADD_AGENDA_DAY_ACCOMMODATION_ROOM':
      if ( state[action.dayId] ) {
        rooms = state[action.dayId].rooms ? state[action.dayId].rooms : {}
        return {
          ...state,
          [action.dayId]: {
            ...state[action.dayId],
            rooms: {
              ...rooms,
              [uuid()]: [],
            }
          }
        }
      } else {
        return state;
      }

    case 'REMOVE_AGENDA_DAY_ACCOMMODATION_ROOM':
      if ( state[action.dayId] ) {
        rooms = state[action.dayId].rooms ? state[action.dayId].rooms : {}
        return {
          ...state,
          [action.dayId]: {
            ...state[action.dayId],
            rooms: {
              ...rooms,
              [action.roomId]: null,
            }
          }
        }
      } else {
        return state;
      }

    case 'ADD_PERSON_TO_ACCOMMODATION_ROOM':
      if ( state[action.dayId] ) {
        rooms = state[action.dayId].rooms ? state[action.dayId].rooms : {}
        index = rooms[action.roomId].indexOf(action.personId);
        if ( index === -1 ) {
          return {
            ...state,
            [action.dayId]: {
              ...state[action.dayId],
              rooms: {
                ...rooms,
                [action.roomId]: [
                  ...rooms[action.roomId],
                  action.personId,
                ],
              }
            }
          }
        } else {
          return state;
        }
      } else {
        return state;
      }

    case 'REMOVE_PERSON_FROM_ACCOMMODATION_ROOM':
      if ( state[action.dayId] ) {
        rooms = state[action.dayId].rooms ? state[action.dayId].rooms : {}
        index = state[action.dayId].rooms[action.roomId].indexOf(action.personId);
        if ( index > -1 ) {
          return {
            ...state,
            [action.dayId]: {
              ...state[action.dayId],
              rooms: {
                ...rooms,
                [action.roomId]: [
                  ...rooms[action.roomId].slice(0, index),
                  ...rooms[action.roomId].slice(index+1),
                ],
              }
            }
          }
        } else {
          return state;
        }
      } else {
        return state;
      }

    default:
      return state;

  }

};

const savingReducer = (state = {}, action) => {

  let index, arr;

  switch(action.type) {

    case 'SAVE_HOMEPAGE_START':
      if ( !state.homepage ) {
        return {
          ...state,
          homepage: true
        };
      } else {
        return state;
      }

    case 'SAVE_HOMEPAGE_SUCCESS':
      if ( state.homepage ) {
        return {
          ...state,
          homepage: false,
        };
      } else {
        return state;
      }

    case 'SAVE_PEOPLE_START':
      if ( !state.people ) {
        return {
          ...state,
          people: true
        };
      } else {
        return state;
      }

    case 'SAVE_PEOPLE_SUCCESS':
      if ( state.people ) {
        return {
          ...state,
          people: false,
        };
      } else {
        return state;
      }

    case 'SAVE_AGENDA_START':
      if ( !state.agenda ) {
        return {
          ...state,
          agenda: true
        };
      } else {
        return state;
      }

    case 'SAVE_AGENDA_SUCCESS':
      if ( state.agenda ) {
        return {
          ...state,
          agenda: false,
        };
      } else {
        return state;
      }

    case 'UPLOAD_HOMEPAGE_IMAGE':
      if ( !state.uploadHomepageImage ) {
        return {
          ...state,
          uploadHomepageImage: true
        };
      } else {
        return state;
      }

    case 'UPLOAD_HOMEPAGE_IMAGE_SUCCESS':
      if ( state.uploadHomepageImage ) {
        return {
          ...state,
          uploadHomepageImage: false,
        };
      } else {
        return state;
      }

    case 'UPLOAD_AGENDA_ITEM_MEDIA':
      arr = state.uploadAgendaItemMedia || [];
      index = arr.indexOf(action.id);
      if ( index === -1 ) {
        return {
          ...state,
          uploadAgendaItemMedia: [
            ...arr,
            action.id,
          ]
        };
      } else {
        return state;
      }

    case 'UPLOAD_AGENDA_ITEM_MEDIA_SUCCESS':
      arr = state.uploadAgendaItemMedia || [];
      index = arr.indexOf(action.id);
      if ( index > -1 ) {
        return {
          ...state,
          uploadAgendaItemMedia: [
            ...arr.slice(0, index),
            ...arr.slice(index+1),
          ],
        };
      } else {
        return state;
      }

    default:
      return state;

  }

};

// *** MAIN REDUCER

export default combineReducers({
  homepageEdit: homepageReducer,
  peopleEdit: peopleReducer,
  agendaEdit: agendaReducer,
  saving: savingReducer,
});

// *** SELECTORS

export const homepageEditSelector = (state) => state.homepageEdit;
export const peopleEditSelector = (state) => state.peopleEdit;
export const agendaEditSelector = (state) => state.agendaEdit;

export const homepageSavingSelector = (state) => state.saving.homepage;
export const peopleSavingSelector = (state) => state.saving.people;
export const agendaSavingSelector = (state) => state.saving.agenda;
export const homepageImageSavingSelector = (state) => state.saving.uploadHomepageImage;
export const agendaItemMediaSavingSelector = (state) => state.saving.uploadAgendaItemMedia;

// *** ACTIONS

// HOMEPAGE

export const saveHomepage = (homepage) => {
  return (dispatch) => {
    dispatch({
      type: 'SAVE_HOMEPAGE_START',
    });
    return apiUpdateHomepage(homepage).then(() => {
      dispatch({
        type: 'SAVE_HOMEPAGE_SUCCESS',
      });
    });
  };
};

export const uploadHomepageImage = (file) => {
  return (dispatch) => {
    dispatch({
      type: 'UPLOAD_HOMEPAGE_IMAGE',
    });
    return uploadFile('/homepage/' + uuid(), file).then(snapshot => {
      dispatch({
        type: 'UPLOAD_HOMEPAGE_IMAGE_SUCCESS',
      });
      return {
        url: snapshot.downloadURL,
        ref: snapshot.ref.location.path,
      };
    });
  };
};

export const editHomepage = (homepage) => {
  return {
    type: 'EDIT_HOMEPAGE',
    homepage: homepage || {},
  };
};

export const cancelEditHomepage = () => {
  return {
    type: 'CANCEL_EDIT_HOMEPAGE',
  };
};

export const updateHomepage = (delta) => {
  return {
    type: 'UPDATE_HOMEPAGE',
    delta,
  };
};

// PEOPLE

export const editPeople = (people) => {
  return {
    type: 'EDIT_PEOPLE',
    people: people || {},
  };
};

export const addPerson = () => {
  return {
    type: 'ADD_PERSON',
  }
};

export const removePerson = (id) => {
  return {
    type: 'REMOVE_PERSON',
    id,
  }
};

export const updatePerson = (id, delta) => {
  return {
    type: 'UPDATE_PERSON',
    id,
    delta,
  }
};

export const cancelEditPeople = () => {
  return {
    type: 'CANCEL_EDIT_PEOPLE',
  };
}

export const savePeople = (people) => {
  return (dispatch) => {
    dispatch({
      type: 'SAVE_PEOPLE_START',
    });
    updatePeople(people).then(() => {
      dispatch({
        type: 'SAVE_PEOPLE_SUCCESS',
      });
    });
  };
};

// AGENDA

export const editAgenda = (agenda) => {
  return {
    type: 'EDIT_AGENDA',
    agenda: agenda || {},
  };
};

export const addAgendaDay = () => {
  return (dispatch, getState) => {
    const dates = agendaDatesSelector(rootAgendaEditSelector(getState()));
    dispatch({
      type: 'ADD_AGENDA_DAY',
      agendaDay: {
        // add the next date in the list by default
        date: moment(dates.sort().reverse()[0]).add({days:1}).format("YYYY-MM-DD"),
        items: {}
      }
    });
  };
};

export const removeAgendaDay = (id) => {
  return {
    type: 'REMOVE_AGENDA_DAY',
    id,
  };
};

export const updateAgendaDay = (id, delta) => {
  return {
    type: 'UPDATE_AGENDA_DAY',
    id,
    delta,
  };
};

export const cancelEditAgenda = () => {
  return {
    type: 'CANCEL_EDIT_AGENDA',
  };
};

export const updateAgendaItem = (dayId, itemId, delta) => {
  return {
    type: 'UPDATE_AGENDA_ITEM',
    dayId,
    itemId,
    delta,
  };
};

export const removeAgendaItem = (dayId, itemId) => {
  return {
    type: 'REMOVE_AGENDA_ITEM',
    dayId,
    itemId,
  };
};

export const addAgendaItem = (dayId, itemId) => {
  return {
    type: 'ADD_AGENDA_ITEM',
    dayId,
  };
};

export const addPersonToAgendaDay = (dayId, personId) => {
  return {
    type: 'ADD_PERSON_TO_AGENDA_DAY',
    dayId,
    personId,
  };
};

export const removePersonFromAgendaDay = (dayId, personId) => {
  return {
    type: 'REMOVE_PERSON_FROM_AGENDA_DAY',
    dayId,
    personId,
  };
};

export const setAgendaDayPeople = (dayId, personIds) => {
  return {
    type: 'SET_AGENDA_DAY_PEOPLE',
    dayId,
    personIds,
  };
};

export const clearAgendaDayPeople = (dayId) => {
  return {
    type: 'CLEAR_AGENDA_DAY_PEOPLE',
    dayId,
  };
};

export const saveAgenda = (agenda) => {
  return (dispatch) => {
    dispatch({
      type: 'SAVE_AGENDA_START',
    });

    updateAgenda(agenda).then(() => {
      dispatch({
        type: 'SAVE_AGENDA_SUCCESS',
      });
    });
  };
};

export const uploadAgendaItemMedia = (itemId, file) => {
  return (dispatch) => {
    dispatch({
      type: 'UPLOAD_AGENDA_ITEM_MEDIA',
      id: itemId,
    });
    return uploadFile('/agendaItem/' + itemId + '/' + uuid(), file).then(snapshot => {
      dispatch({
        type: 'UPLOAD_AGENDA_ITEM_MEDIA_SUCCESS',
        id: itemId,
      });
      return {
        url: snapshot.downloadURL,
        ref: snapshot.ref.location.path,
      };
    });
  };
};

export const addAgendaDayAccommodationRoom = (dayId) => {
  return {
    type: 'ADD_AGENDA_DAY_ACCOMMODATION_ROOM',
    dayId,
  };
};

export const removeAgendaDayAccommodationRoom = (dayId, roomId) => {
  return {
    type: 'REMOVE_AGENDA_DAY_ACCOMMODATION_ROOM',
    dayId,
    roomId,
  };
};

export const addPersonToAccommodationRoom = (dayId, roomId, personId) => {
  return {
    type: 'ADD_PERSON_TO_ACCOMMODATION_ROOM',
    dayId,
    roomId,
    personId,
  };
};

export const removePersonFromAccommodationRoom = (dayId, roomId, personId) => {
  return {
    type: 'REMOVE_PERSON_FROM_ACCOMMODATION_ROOM',
    dayId,
    roomId,
    personId,
  };
};

// POINTS

export const addPointsChange = (personId, change) => {
  return (dispatch) => {
    const delta = {
      personId,
      change,
      ts: Date.now(),
    };
    dispatch({
      type: 'POINTS_CHANGE',
      ...delta,
    });
    apiAddPointsChange(delta);
  };
};



// WEBPACK FOOTER //
// ./src/reducers/adminReducer.js